import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import call from "./Images/call.png";
import mail from "./Images/mail.png";
import adddress from "./Images/address.png";
import insta from "./Images/insta.png";
import facebook from "./Images/facebook.png";
import linkdin from "./Images/linkdin.png";
import youtube from "./Images/youtube.png";
import logo from "./Images/RMB-Strip-Jaipur.png";
import { RiArrowDownSLine, RiCloseLine, RiMenuLine } from "react-icons/ri";

import { useTheme } from "../context/ThemeContext";

const NAV_ITEMS = ['Home', 'About', 'Members', 'Meetings', 'Directors', 'Contact'];

const ABOUT_LINKS = [
  { label: 'About RMB', href: '/about' },
  { label: 'RMB Leaders', href: '/rmbleaders' },
  { label: 'RMB Jaipur', href: '/rmbjaipur' },
];

const DIRECTORS_LINKS = [
  { label: 'Leadership Team', href: '/leadership' },
  { label: 'Coordinators Team', href: '/coordinators' },
];

const SOCIAL_LINKS = [
  { src: insta, href: 'https://www.instagram.com/rotarymeansbusinessjaipur/', alt: 'Instagram' },
  { src: facebook, href: 'https://www.facebook.com/RMBJaipur', alt: 'Facebook' },
  { src: linkdin, href: 'https://www.linkedin.com/', alt: 'LinkedIn' },
  { src: youtube, href: 'https://www.youtube.com/channel/UCc82djijUfxVlxUEAMZlklQ', alt: 'YouTube' },
];

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const [submenu, setSubmenu] = useState<null | 'about' | 'directors'>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSubmenu, setMobileSubmenu] = useState<null | 'about' | 'directors'>(null);
  const [activemenu, setActivemenu] = useState('Home');
  const [newsHeading, setNewsHeading] = useState('');
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    axios.get("https://rmbbackend.rmbjaipur.com/auth/newsheading")
      .then(res => {
        if (res.data?.data?.[0]?.title) {
          setNewsHeading(res.data.data[0].title);
        }
      })
      .catch(err => console.error("Error fetching news heading in Header:", err));
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (headerRef.current && !headerRef.current.contains(e.target as Node)) {
        setSubmenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  const handleNavClick = (item: string) => {
    setActivemenu(item);
    if (item === 'About') {
      setSubmenu(prev => prev === 'about' ? null : 'about');
    } else if (item === 'Directors') {
      setSubmenu(prev => prev === 'directors' ? null : 'directors');
    } else {
      setSubmenu(null);
    }
  };

  return (
    <div ref={headerRef}>
      <header>
        {/* Top Bar */}
        <div className="flex flex-wrap justify-center w-full bg-[#000E3F] items-center px-[4%] lg:px-[8%] py-2">
          <div className="flex flex-wrap md:w-4/5 w-full items-center text-[#F5F5F5] text-[12px] gap-x-6 gap-y-1">
            <span className="flex items-center gap-1.5">
              <img className="w-3.5 h-3.5" src={call} alt="Phone" />
              +91 9214001400
            </span>
            <span className="flex items-center gap-1.5">
              <img className="w-3.5 h-3.5" src={mail} alt="Email" />
              rotarymeansbuisnessjaipur@gmail.com
            </span>
            <span className="hidden md:flex items-center gap-1.5">
              <img className="w-3.5 h-3.5" src={adddress} alt="Address" />
              209-A, Windsor Plaza, Sansar Chandra Road, Jaipur-302001
            </span>
          </div>
          <div className="flex md:w-1/5 justify-end items-center gap-3">
            {/* 1-Click Theme Switcher */}
            <button
              onClick={toggleTheme}
              className="flex items-center gap-1 px-3 py-1 rounded-full bg-[#FDBC12] text-[#0A2451] hover:bg-amber-300 font-black text-xs transition-all shadow cursor-pointer"
              title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              <span>{theme === 'dark' ? '☀️ Light' : '🌙 Dark'}</span>
            </button>

            {SOCIAL_LINKS.map(({ src, href, alt }) => (
              <a key={alt} href={href} target="_blank" rel="noreferrer" className="hidden sm:inline-block hover:opacity-75 transition-opacity">
                <img className="h-4 w-4" src={src} alt={alt} />
              </a>
            ))}
          </div>
        </div>

        {/* Main Nav Bar */}
        <div className="bg-[#E1E8F0] px-[4%] lg:px-[8%] flex flex-wrap w-full justify-between items-center relative">
          {/* Logo */}
          <div className="py-3">
            <a href="/">
              <img className="h-9 lg:h-11 w-auto cursor-pointer" src={logo} alt="RMB Jaipur Logo" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center h-full">
            <ul className="flex items-center gap-7">
              {NAV_ITEMS.map((item) => {
                const isDropdown = item === 'About' || item === 'Directors';
                const isActive = activemenu === item;
                return (
                  <li key={item} className="relative">
                    <button
                      onClick={() => handleNavClick(item)}
                      className={`flex items-center gap-1 py-5 text-sm font-semibold text-[#101729] border-b-2 transition-all cursor-pointer ${isActive ? 'border-[#FDBC12] text-[#0A2451]' : 'border-transparent hover:border-[#FDBC12] hover:text-[#0A2451]'
                        }`}
                    >
                      {isDropdown ? (
                        <>
                          {item}
                          <RiArrowDownSLine
                            className={`transition-transform duration-200 ${(item === 'About' && submenu === 'about') || (item === 'Directors' && submenu === 'directors')
                                ? 'rotate-180' : ''
                              }`}
                          />
                        </>
                      ) : (
                        <a href={`/${item === 'Contact' ? 'contact' : item.toLowerCase()}`} className="text-inherit">
                          {item === 'Contact' ? 'Contact Us' : item}
                        </a>
                      )}
                    </button>

                    {/* About Dropdown */}
                    {item === 'About' && submenu === 'about' && (
                      <ul className="absolute top-full left-0 bg-white shadow-xl rounded-xl border border-slate-100 py-2 w-48 z-50 animate-fade-in">
                        {ABOUT_LINKS.map(link => (
                          <li key={link.label}>
                            <a
                              href={link.href}
                              className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] font-semibold transition-colors"
                            >
                              {link.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* Directors Dropdown */}
                    {item === 'Directors' && submenu === 'directors' && (
                      <ul className="absolute top-full left-0 bg-white shadow-xl rounded-xl border border-slate-100 py-2 w-52 z-50 animate-fade-in">
                        {DIRECTORS_LINKS.map(link => (
                          <li key={link.label}>
                            <a
                              href={link.href}
                              className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] font-semibold transition-colors"
                            >
                              {link.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3 py-3">
            <a
              href="/register"
              className="border-2 border-[#0A2451] rounded-lg px-4 py-2 text-[#0A2451] text-sm font-bold hover:bg-[#0A2451] hover:text-white transition-all"
            >
              Register
            </a>
            <a
              href="/login"
              className="bg-[#0A2451] rounded-lg px-5 py-2 text-white text-sm font-bold hover:bg-[#FDBC12] hover:text-[#0A2451] transition-all"
            >
              Log In
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="lg:hidden p-2 rounded-lg text-[#0A2451] hover:bg-[#0A2451]/10 transition-colors"
            aria-label="Open menu"
          >
            <RiMenuLine size={26} />
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 z-[100] flex">
            {/* Backdrop */}
            <div
              className="absolute inset-0 bg-black/40 backdrop-blur-sm"
              onClick={() => setMobileMenuOpen(false)}
            />

            {/* Drawer */}
            <div className="relative ml-auto w-4/5 max-w-xs bg-white h-full shadow-2xl flex flex-col overflow-y-auto">
              {/* Drawer Header */}
              <div className="flex justify-between items-center p-4 border-b border-slate-100">
                <img src={logo} alt="RMB Jaipur" className="h-8 w-auto" />
                <button
                  onClick={() => setMobileMenuOpen(false)}
                  className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 transition-colors"
                  aria-label="Close menu"
                >
                  <RiCloseLine size={22} />
                </button>
              </div>

              {/* Mobile Nav Links */}
              <nav className="flex-1 py-3">
                <ul className="space-y-0.5">
                  <li>
                    <a href="/" className="flex items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors">
                      Home
                    </a>
                  </li>

                  {/* About with submenu */}
                  <li>
                    <button
                      onClick={() => setMobileSubmenu(prev => prev === 'about' ? null : 'about')}
                      className="w-full flex justify-between items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors"
                    >
                      About Us
                      <RiArrowDownSLine className={`transition-transform ${mobileSubmenu === 'about' ? 'rotate-180' : ''}`} />
                    </button>
                    {mobileSubmenu === 'about' && (
                      <ul className="bg-slate-50 border-l-4 border-[#FDBC12] ml-4">
                        {ABOUT_LINKS.map(link => (
                          <li key={link.label}>
                            <a href={link.href} className="block px-5 py-2.5 text-sm font-medium text-slate-600 hover:text-[#0A2451] transition-colors">
                              → {link.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

                  <li>
                    <a href="/members" className="flex items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors">
                      Members
                    </a>
                  </li>
                  <li>
                    <a href="/meetings" className="flex items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors">
                      Meetings
                    </a>
                  </li>

                  {/* Directors with submenu */}
                  <li>
                    <button
                      onClick={() => setMobileSubmenu(prev => prev === 'directors' ? null : 'directors')}
                      className="w-full flex justify-between items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors"
                    >
                      Directors
                      <RiArrowDownSLine className={`transition-transform ${mobileSubmenu === 'directors' ? 'rotate-180' : ''}`} />
                    </button>
                    {mobileSubmenu === 'directors' && (
                      <ul className="bg-slate-50 border-l-4 border-[#FDBC12] ml-4">
                        {DIRECTORS_LINKS.map(link => (
                          <li key={link.label}>
                            <a href={link.href} className="block px-5 py-2.5 text-sm font-medium text-slate-600 hover:text-[#0A2451] transition-colors">
                              → {link.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

                  <li>
                    <a href="/contact" className="flex items-center px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-[#FDBC12]/10 hover:text-[#0A2451] transition-colors">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </nav>

              {/* Mobile CTA */}
              <div className="p-4 border-t border-slate-100 space-y-2">
                <a
                  href="/register"
                  className="block text-center border-2 border-[#0A2451] rounded-xl py-2.5 text-sm font-bold text-[#0A2451] hover:bg-[#0A2451] hover:text-white transition-all"
                >
                  Register
                </a>
                <a
                  href="/login"
                  className="block text-center bg-[#0A2451] rounded-xl py-2.5 text-sm font-bold text-white hover:bg-[#FDBC12] hover:text-[#0A2451] transition-all"
                >
                  Log In
                </a>
                {/* Mobile socials */}
                <div className="flex justify-center gap-4 pt-2">
                  {SOCIAL_LINKS.map(({ src, href, alt }) => (
                    <a key={alt} href={href} target="_blank" rel="noreferrer" className="hover:opacity-70 transition-opacity">
                      <img className="h-5 w-5" src={src} alt={alt} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;
